<template>
  <div>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="formInline.name" placeholder="姓名、学号、身份证号、电话"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
          <el-button type="success" size="medium" @click="addStudent">新增考生</el-button>
          <el-button type="primary" size="medium" @click="exportFn">下载模版</el-button>

          <el-upload class="upload-demo" :action="uploadUrl2" :data="datas" :headers="headers1" :show-file-list="false" :on-success="handleAvatarSuccess1" style="display:inline-block">
            <el-button type="primary" size="medium">导入考生</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">

      <el-table-column prop="name" label="考试姓名">
      </el-table-column>
      <el-table-column prop="code" label="学号">
      </el-table-column>
      <el-table-column prop="idcard" label="身份证号">
      </el-table-column>
      <el-table-column prop="exam_sequence" label="准考证号">
      </el-table-column>
      <el-table-column prop="grade_class" label="班级">

      </el-table-column>
      <el-table-column prop="teacher_name" label="班主任姓名">

      </el-table-column>
      <el-table-column prop="mobile" label="联系电话">

      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">

          <!-- <el-button type="text" size="small">查看</el-button> -->
          <el-button type="text" size="small" @click="editStudent(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="delStudent(scope.row,scope.$index)"> 删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;margin-top:20px">
      <el-pagination background @current-change="pageCurrentChange" :page-count="pageform.pages" :current-page="pageform.pageNum" layout="total, prev, pager, next" :total="pageform.total" :page-size='10'>
      </el-pagination>
    </div>
  </div>

</template>

<script>
    export default {
        name: "studentManage",
        data() {
            return {

                id: this.$route.query.id,
                uploadUrl: this.GLOBAL.BASE_URL + 'api/images',
                imageUrl: '',
                uploadUrl2: this.GLOBAL.BASE_URL + 'api/exam/import-student',
                formInline: {
                    name: ''
                },

                // 分页插件
                pageform: {
                    total: 10,
                    pages: 10,  // 总页数
                    pageNum: 1, // 当前的页码
                    pageSize: 10, // 每页显示条目个数
                },

                tableData: [],
            };
        },
        computed: {

        },
        created() {
                this.getData()//获取考生列表
        },

        methods: {
            handleAvatarSuccess1(res, file) {


                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.getData();
                } else {
                    this.$message.error(res.message);
                }

            },
            //删除考试
            delStudent(item, index) {
                this.$confirm('确定要删除该数据吗？')
                    .then(_ => {


                        this.$http.delStudent({
                            exam_id: this.id,
                            id: item.id,
                        })
                            .then(res => {
                                if (res.code == 1) {
                                    this.$message.success("删除成功")
                                    this.tableData.splice(index, 1)

                                } else {
                                    this.$message.error(res.message)
                                }

                            })
                            .catch(err => {
                                console.log(err);
                            })
                    })
                    .catch(_ => { });
            },
            //下载学生模版
            exportFn() {
                window.open(this.GLOBAL.BASE_URL + "api/download-student-import-tpl")
            },
            search() {
                this.pageform.pageNum = 1;
                this.getData()
            },
            // /新增考生
            addStudent() {
                this.$router.push({
                    name: 'addStudent',
                    query: {
                        id: this.id
                    }
                })
            },
            //编辑考生
            editStudent(item) {
                this.$router.push({
                    name: 'addStudent',
                    query: {
                        id: this.id,
                        studentId: item.id

                    }
                })
            },
            // 获取考生列表
            getData() {
                this.$http.studentsList({
                    name: this.formInline.name,
                    id: this.id,
                    page: this.pageform.pageNum,
                    page_size: 10,
                })
                    .then(res => {
                        this.tableData = res.data;
                        this.pageform.pages = res.meta.last_page;
                        this.pageform.total = res.meta.total;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
                // console.log('当前页:'+ val);
                this.pageform.pageNum = val;
                this.getData();
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/theoryManage/studentManage.vue